import { api } from '@/api'

export interface ToggleServiceProviderActivationPayload {
  is_active: boolean
}

export function toggleServiceProviderActivationAction(id: string, payload: ToggleServiceProviderActivationPayload) {
  return api.v2.patch(`/service-providers/${id}/toggle-activation`, payload as unknown as Record<string, unknown>)
}
